import { useState, useCallback } from 'react';
import { apiClient, apiBaseUrl } from './client';

export function useApi() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(async (
    path: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
    options?: {
      params?: Record<string, unknown>;
      body?: unknown;
      headers?: Record<string, string>;
      returnType?: 'data' | 'response'
    },
  ) => {
    try {
      setLoading(true);
      setError(null);

      let response: { data?: unknown; error?: unknown };
      // Use any to bypass strict typing for generic wrapper
      const clientOptions: any = options ? {} : undefined;
      if (options) {
        if (options.body) clientOptions.body = options.body;
        if (options.params) clientOptions.params = options.params;
        if (options.headers) clientOptions.headers = options.headers;
      }

      // Note: This code looks dirty as hell. It should be cleaned up.
      switch (method) {
        case 'GET':
          response = await (apiClient.GET as any)(path, clientOptions);
          break;
        case 'POST':
          response = await (apiClient.POST as any)(path, clientOptions);
          break;
        case 'PUT':
          response = await (apiClient.PUT as any)(path, clientOptions);
          break;
        case 'DELETE':
          response = await (apiClient.DELETE as any)(path, clientOptions);
          break;
        case 'PATCH':
          response = await (apiClient.PATCH as any)(path, clientOptions);
          break;
        default:
          throw new Error(`Unsupported method: ${method}`);
      }

      if (response.error) {
        throw new Error(JSON.stringify(response.error) || 'API request failed');
      }

      return (options?.returnType || 'data') === 'data' ? response.data : response;
    } catch (err) {
      const error = err instanceof Error ? err : new Error('Unknown error');
      setError(error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  return { request, loading, error, apiBaseUrl };
}